export default __webpack_public_path__ + "static/poynt-5-card 1-ded84d77694683d1197175ee798fa8d8.png";